import React, {Fragment, useState, useEffect} from 'react'
import {Button} from 'react-bootstrap'
import '../Overview.css'
import Modal from 'react-bootstrap/Modal'
import Forms from './Form'
import UserService from '../../../../../services/user'
import MasterService from '../../../../../services/master'
import useServices from '../../../../../utils/hooks/useServices'
import Dropdown from 'react-bootstrap/Dropdown'
import {toast} from 'react-toastify'
import Spinner from 'react-bootstrap/Spinner'
import MasterServices from '../../../../../services/master'
import {useSearchParams} from 'react-router-dom'
import {PageTitle} from '_metronic/layout/core'

const Skill = () => {
  const [searchParams] = useSearchParams()
  const [show, setShow] = useState(false)
  const [isEdit, setIsEdit] = useState(false)
  const [formValue, setFormValue] = useState<any>({})
  const [submit, setSubmit] = useState(false)
  const [data, setData] = useState<any>({})
  const [dataUser, loading, isError, triggerRefresh] = useServices(
    searchParams.get('alumni') ? MasterServices.showUser : UserService.getProfile,
    searchParams.get('alumni')
  )
  const [loadingDelete, setLoadingDelete] = useState(false)
  const [profiencies, setProficiencies] = useState<any>([])
  const [skills, setSkills] = useState<any>([])

  useEffect(() => {
    if (searchParams.get('alumni')) {
      setData(dataUser?.data)
    } else {
      setData(dataUser)
    }
  }, [dataUser])

  useEffect(() => {
    getMaster()
    getSkills()
    return () => {
    }
  }, [])

  const getMaster = async () => {
    try {
      await MasterService.getProficiency({type: ['SKILL'], is_active: 1}).then((res) => {
        setProficiencies(res.data?.data)
      })
    } catch (error) {}
  }

  const getSkills = async () => {
    try {
      await MasterService.getSkill({is_active: 1}).then((res) => {
        setSkills(res.data?.data)
      })
    } catch (error) {}
  }

  const toggle = () => {
    if (show) {
      setIsEdit(false)
      setFormValue({})
    }
    setShow(!show)
  }

  const onChange = (e: any) => {
    const {name, value} = e.target

    setFormValue({
      ...formValue,
      [name]: value,
    })
  }

  const handleDelete = async (id: any) => {
    try {
      if (!window.confirm('Yakin Ingin Menghapus Keahlian ?')) {
        return
      }
      setLoadingDelete(true)
      setSubmit(true)

      await UserService.deleteSkill(id).then(() => {
        toast.success('Keahlian berhasil dihapus')
        triggerRefresh()
      })
    } catch (error) {
      toast.error('Keahlian gagal dihapus')
    } finally {
      setSubmit(false)
      setLoadingDelete(false)
    }
  }
  return (
    <div>
      <Modal show={show} onHide={toggle} size='lg'>
        <Modal.Header closeButton>
          <Modal.Title>{isEdit ? 'Form' : 'Form'} Keahlian</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {show && (
            <Forms
              onChange={onChange}
              editFormValue={formValue}
              toggle={toggle}
              getData={triggerRefresh}
              master={profiencies}
              skills={skills}
            />
          )}
        </Modal.Body>
      </Modal>
      <div className='row'>
        <div className='col-md-12'>
          <div className='row'>
            <div className='col-md-6'>
              {localStorage.getItem('role') == 'Alumni' && (
                <PageTitle
                  breadcrumbs={[
                    {
                      title: 'Dashboard',
                      path: '/dashboard',
                      isSeparator: false,
                      isActive: false,
                    },
                    {
                      title: '/',
                      path: '',
                      isSeparator: false,
                      isActive: false,
                    },
                  ]}
                >
                  Keahlian
                </PageTitle>
              )}
              <h4>Keahlian</h4>
            </div>
            <div className='col-md-6'>
              {!searchParams.get('alumni') && (
                <Button
                  onClick={toggle}
                  className='btn btn-primary btn-sm btn-add'
                  style={{float: 'right'}}
                >
                  Tambah
                </Button>
              )}
            </div>
          </div>
        </div>
        {/* start data alamat KTP */}
        <div className='col-md-12 d-grid gap-10'>
          <div style={{textAlign: 'center'}}>
            {loading && (
              <Spinner animation='border' role='status' style={{height: '100px', width: '100px'}} />
            )}
            {!loading && data?.skills?.length === 0 && <h3>Tidak ada data Keahlian</h3>}
          </div>

          <div className='d-grid gap-10'>
            {data?.skills?.map((item: any, key: any) => {
              return (
                <Fragment key={Math.random()}>
                  <div className='card-custom'>
                    <div className='row'>
                      <div className='col-md-6 p-2'>
                        <h5>{item?.skill?.skills_name}</h5>
                      </div>
                      <div className='col-md-6'>
                        {!searchParams.get('alumni') && (
                          <Dropdown>
                            <Dropdown.Toggle
                              id='dropdown-basic'
                              style={{float: 'right'}}
                              className='btn btn-primary btn-sm'
                            >
                              Aksi
                            </Dropdown.Toggle>
                            <Dropdown.Menu>
                              <Dropdown.Item
                                href='#/action-1'
                                onClick={() => {
                                  setIsEdit(true)
                                  setFormValue({
                                    proficiencies_id: item?.user_skills_proficiencies_id,
                                    skills: item?.skill?.skills_name,
                                    is_certificate: item?.user_skills_certificate,
                                    institution: item?.user_skills_institution,
                                    total_experience: item?.user_skills_total_experience,
                                    description: item?.user_skills_description,
                                    rowDetail: item,
                                  })
                                  toggle()
                                }}
                              >
                                Edit
                              </Dropdown.Item>
                              <Dropdown.Item
                                href='#/action-2'
                                onClick={() => {
                                  handleDelete(item.user_skills_id)
                                }}
                              >
                                Hapus
                              </Dropdown.Item>
                            </Dropdown.Menu>
                          </Dropdown>
                        )}
                      </div>
                      <div className='col-md-12'>
                        <div className='row'>
                          <div className='col-md-6 p-2'>
                            <p>Tingkat Kemahiran</p>
                            <p className='fw-bold'>{item.proficiency?.proficiencies_name}</p>
                          </div>
                          <div className='col-md-6 p-2'>
                            <p>Lama Pengalaman</p>
                            <p className='fw-bold'>{item?.user_skills_total_experience} Tahun</p>
                          </div>
                        </div>
                        <div className='row'>
                          <div className='col-md-6 p-2'>
                            <p>Sertifikat</p>
                            <p className='fw-bold'>
                              {item.user_skills_certificate == 1 ? 'Ya' : 'Tidak'}
                            </p>
                          </div>
                          <div className='col-md-6 p-2'>
                            <p>Nama Institusi Penerbit</p>
                            <p className='fw-bold'>{item?.user_skills_institution || '-'}</p>
                          </div>
                        </div>
                      </div>
                      <div className='col-md-12 p-2'>
                        <p>Deskripsi Kemampuan</p>
                        <p className='fw-bold'>{item.user_skills_description || '-'}</p>
                      </div>
                      {item?.document_url_full && item?.user_skills_certificate == 1 ? (
                        <div className='col-md-12 p-2'>
                          <p>Dokumen Pendukung</p>
                          <a
                            href={item?.document_url_full}
                            target='_blank'
                            className='btn btn-primary btn-sm'
                          >
                            Sertifikat
                          </a>
                        </div>
                      ) : null}
                    </div>
                  </div>
                </Fragment>
              )
            })}
          </div>
        </div>
      </div>
      {/* end data alamat KTP */}
      {/* end content */}
    </div>
  )
}

export default Skill
